// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PrescriptionFulfillment from './pages/PrescriptionFulfillment';
// Import pages
import Home from './pages/Home';
import FreeHomeDeliveryPage from './pages/FreeHomeDelivery';

import Refills from './pages/Refills';
import Transfer from './pages/Transfer';
import AboutUs from './pages/AboutUs';
import Contactus from './pages/ContactUs';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Halloween from './pages/Halloween';
import Thanksgiving from './pages/Thanksgiving';
import InsuranceWelcome from './pages/Welcome';
import InsuranceCard from './pages/eRxInsCard';
import Christmas from './pages/Christmas';
import RefillMadeEasy from './pages/RefillMadeEasy';
import Topbar from './components/Topbar';
import HealthProducts from './pages/HealthProduct';
import OverTheCounterMedications from './pages/OverTheCounter';
import Vaccinations from './pages/Vaccination';
import Services from './pages/Services';
import './App.css';

function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Topbar />
         <div className="body-offset">
        <Header />
</div>
        <main className="flex-fill">
          <Routes>
            <Route path="/" element={<Home />} />
            
            <Route path="/services/free-home-delivery" element={<FreeHomeDeliveryPage />} />
            <Route path="/services/over-the-counter-medications" element={<OverTheCounterMedications />} />
            <Route path="/services/health-product" element={<HealthProducts />} />
            
            <Route path="/refills" element={<Refills />} />
            <Route path="/transfer" element={<Transfer />} />
            <Route path="/about" element={<AboutUs />} />
             <Route path="/services" element={<Services />} />
            <Route path="/services/refill-made-easy" element={<RefillMadeEasy />} />
            <Route path="/services/prescription-fulfillment" element={<PrescriptionFulfillment />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
              <Route path="/services/Vaccinations" element={<Vaccinations/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/halloween" element={<Halloween />} />
            <Route path="/thanksgiving" element={<Thanksgiving />} />
            <Route path="/insurance/welcome" element={<InsuranceWelcome />} />
            <Route path="/insurance/erx-ins-card" element={<InsuranceCard />} />
            <Route path="/christmas" element={<Christmas />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
